import { createContext, useState } from "react";

export const StorefrontContext = createContext();

export const StorefrontContextProvider = ({ children }) => {
    const [image, setImage] = useState({});

    const [logoImage, setLogoImage] = useState('');

    // const defaultCarouselAlert = [
    //     {
    //         index: 1,
    //         bannerAlert: false,
    //         bannerAvailable: false,
    //     },
    //     {
    //         index: 2,
    //         bannerAlert: false,
    //         bannerAvailable: false,
    //     },
    //     {
    //         index: 3,
    //         bannerAlert: false,
    //         bannerAvailable: false,
    //     },
    //     {
    //         index: 4,
    //         bannerAlert: false,
    //         bannerAvailable: false,
    //     },
    //     {
    //         index: 5,
    //         bannerAlert: false,
    //         bannerAvailable: false,
    //     }
    // ]

    // const defaultAlert = {
    //     backgroundImage: false,
    //     singleBanner: false,
    //     carouselBanner: defaultCarouselAlert,
    // }

    // const [alert, setAlert] = useState(defaultAlert);

    const defaultSingleBanner = {
        category: {},
        categoryCollection: {},
        customCollection: {},
        product: {},
        image: {},
    }

    const defaultCarouselBanner = [
        {
            title: 'Banner 1',
            image: {},
            altText: '',
            link: defaultSingleBanner,
        },
        {
            title: 'Banner 2',
            image: {},
            altText: '',
            link: defaultSingleBanner,
        },
        {
            title: 'Banner 3',
            image: {},
            altText: '',
            link: defaultSingleBanner,
        },
        {
            title: 'Banner 4',
            image: {},
            altText: '',
            link: defaultSingleBanner,
        },
        {
            title: 'Banner 5',
            image: {},
            altText: '',
            link: defaultSingleBanner,
        },
    ];

    const [singleBanner, setSingleBanner] = useState(defaultSingleBanner);
    const [singleBannerDesktop, setSingleBannerDesktop] = useState(defaultSingleBanner);

    const [carouselBanner, setCarouselBanner] = useState(defaultCarouselBanner);
    const [carouselBannerDesktop, setCarouselBannerDesktop] = useState(defaultCarouselBanner);

    const [categorySection, setCategorySection] = useState({
        title: '',
        categories: [],
    });
    const [categorySectionDesktop, setCategorySectionDesktop] = useState({
        title: '',
        categories: [],
    });

    const [categoryCollectionsList, setCategoryCollectionsList] = useState({
        title: '',
        category: {},
        categoryCollection: {},
    });
    const [categoryCollectionsListDesktop, setCategoryCollectionsListDesktop] = useState({
        title: '',
        category: {},
        categoryCollection: {},
    });

    const [customCollection, setCustomCollection] = useState({
        title: '',
        customCollection: {},
    });
    const [customCollectionDesktop, setCustomCollectionDesktop] = useState({
        title: '',
        customCollection: {},
    });

    const [offerSection, setOfferSection] = useState({
        title: '',
        offers: [],
    });
    const [offerSectionDesktop, setOfferSectionDesktop] = useState({
        title: '',
        offers: [],
    });

    const defaultAboutOne = {
        image: {},
        altText: '',
        heading: '',
        description: '',
    }

    const defaultAboutTwo = {
        heading: '',
        description: '',
    }

    const defaultAboutThree = {
        image: {},
        altText: '',
        heading: '',
        description: '',
    }

    const defaultFeaturesOne = [
        {
            title: 'Feature 1',
            image: {},
            altText: '',
            heading: '',
            description: '',
        }
    ]

    const defaultFeaturesTwo = [
        {
            title: 'Feature 1',
            image: {},
            altText: '',
            heading: '',
        }
    ]

    const [aboutOne, setAboutOne] = useState(defaultAboutOne);
    const [aboutOneDesktop, setAboutOneDesktop] = useState(defaultAboutOne);

    const [aboutTwo, setAboutTwo] = useState(defaultAboutTwo);
    const [aboutTwoDesktop, setAboutTwoDesktop] = useState(defaultAboutTwo);

    const [aboutThree, setAboutThree] = useState(defaultAboutThree);
    const [aboutThreeDesktop, setAboutThreeDesktop] = useState(defaultAboutThree);

    const [featuresOne, setFeaturesOne] = useState(defaultFeaturesOne);
    const [featuresOneDesktop, setFeaturesOneDesktop] = useState(defaultFeaturesOne);

    const [featuresTwo, setFeaturesTwo] = useState(defaultFeaturesTwo);
    const [featuresTwoDesktop, setFeaturesTwoDesktop] = useState(defaultFeaturesTwo);

    const [selectedProducts, setSelectedProducts] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState({});
    const [selectedCollection, setSelectedCollection] = useState({});
    const [selectedCustomCollection, setSelectedCustomCollection] = useState({});

    const contextValue = {
        image,
        setImage,
        selectedProducts,
        setSelectedProducts,
        selectedCategory,
        setSelectedCategory,
        selectedCollection,
        setSelectedCollection,
        selectedCustomCollection,
        setSelectedCustomCollection,

        defaultSingleBanner,
        singleBanner,
        setSingleBanner,

        singleBannerDesktop,
        setSingleBannerDesktop,

        defaultCarouselBanner,
        carouselBanner,
        setCarouselBanner,
        carouselBannerDesktop,
        setCarouselBannerDesktop,

        categorySection,
        setCategorySection,
        categorySectionDesktop,
        setCategorySectionDesktop,

        categoryCollectionsList,
        setCategoryCollectionsList,
        categoryCollectionsListDesktop,
        setCategoryCollectionsListDesktop,

        customCollection,
        setCustomCollection,
        customCollectionDesktop,
        setCustomCollectionDesktop,

        offerSection,
        setOfferSection,
        offerSectionDesktop,
        setOfferSectionDesktop,

        logoImage,
        setLogoImage,

        defaultAboutOne,
        aboutOne,
        setAboutOne,
        aboutOneDesktop,
        setAboutOneDesktop,

        defaultAboutTwo,
        aboutTwo,
        setAboutTwo,
        aboutTwoDesktop,
        setAboutTwoDesktop,

        defaultAboutThree,
        aboutThree,
        setAboutThree,
        aboutThreeDesktop,
        setAboutThreeDesktop,

        defaultFeaturesOne,
        featuresOne,
        setFeaturesOne,
        featuresOneDesktop,
        setFeaturesOneDesktop,

        defaultFeaturesTwo,
        featuresTwo,
        setFeaturesTwo,
        featuresTwoDesktop,
        setFeaturesTwoDesktop,

        // alert,
        // setAlert,
        // defaultAlert,
        // defaultCarouselAlert,
    };

    return (
        <StorefrontContext.Provider value={ contextValue }>
            { children }
        </StorefrontContext.Provider>
    );
}
